import moment from "moment";
import { getConfig } from "@root/config/config";
import { regionContent } from "@kursk/content/regionContent";

const config = getConfig();

export const checkShouldShowEventPlugImage = (
  entityType: string,
  entity: { end: number } | object
): boolean => {
  if (config.features.pastEventsPlug.enabled && entityType === 'events' && 'end' in entity) {
    const eventEndTime = moment.tz(entity.end, regionContent.timezone).valueOf()
    const currentTime = moment.tz(regionContent.timezone).valueOf();

    return eventEndTime < currentTime;
  }

  return false;
}
